<div class="modal-class">
    <div class="modal-header">
        <h5 class="modal-title">Profile Details</h5>
        <span class="fa fa-close" tabindex="-1" aria-label="Close" (click)="activeModal.close()"></span>
    </div>
    <div class="modal-body">
        <ng-container *ngTemplateOutlet="userinfo;"> </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="!profileForm.valid"
            (click)="saveProfile()">Save</button>
        <button type="button" class="btn btn-default" (click)="activeModal.close()">Cancel</button>
    </div>
</div>

<ng-template #userinfo [formGroup]="profileForm">
    <div class="text-center">
        <img (click)="triggerClick()" class="profile-photo" height="100px" [src]="photo">
        <input #file accept="image/*" (change)="onSelectFile($event)" type="file" class="d-none">
    </div>
    <div class="form-group">
        <label>First Name<span class="required-text">*</span></label>
        <input type="text" formControlName="firstname" class="form-control" required>
    </div>
    <div class="form-group">
        <label>Last Name<span class="required-text">*</span></label>
        <input type="text" formControlName="lastname" class="form-control" required>
    </div>
    <div class="form-group">
        <label>Email<span class="required-text">*</span></label>
        <input type="email" formControlName="email" class="form-control" required>
    </div>
    <div class="form-group">
        <label>Mobile<span class="required-text">*</span></label>
        <input type="number" formControlName="mobilephone" class="form-control" required>
    </div>
</ng-template>